export const US = "US";
export const INDIA_COUNTRY_CODE = "IN";

export const SUGGESTED_COUNTRIES = ["United States", "United Kingdom", "India"];
